import timestampFormatter from '@utils/timestamp-formatter';
import { AppsService } from '@/common/apps/apps.service.js';
import get from 'lodash/get';
import sanitizeHtml from 'sanitize-html';

//  eslint-disable-next-line id-length
export const tooltipFormatter = function (_, body) {
    const appPlatform = get(this.point, 'app.platform');
    const color = this.point.hideColorInTooltip ? null : this.point.color || this.series.color;
    let appIcon = '';

    if (appPlatform) {
        switch (appPlatform) {
            case 'web': {
                appIcon =
                    '<span style="margin: 3px 6px 0 0"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-monitor" display="grid"><rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect><line x1="8" y1="21" x2="16" y2="21"></line><line x1="12" y1="17" x2="12" y2="21"></line></svg></span>';
                break;
            }
            default: {
                appIcon = `<span class="fa ${AppsService.getAppIconLabel(
                    appPlatform,
                )}" style="margin: 4px 6px 0 0"></span>`;
            }
        }
    }

    const colorIcon = color ? `<span class="chart-tooltip-color-icon" style="color: ${color}">\u2B24</span>` : '';
    const pointsMatch = this.x && this.x === this.point.x;
    const periodExists = !!this.series.userOptions.period;
    const periodLabel =
        pointsMatch && periodExists
            ? `<span class="chart-tooltip-date">${timestampFormatter({
                timestamp: this.point.x,
                period: this.series.userOptions.period,
            })}</span>`
            : '';

    const dateRangeLabel = this.point.dateRangeLabel
        ? `<div class="chart-tooltip-date">${this.point.dateRangeLabel}</div>`
        : '';
    const valueLabel = this.point.valueLabel || this.y.toLocaleString();
    const valueSubLabel = this.point.valueSubLabel
        ? `<span class="chart-tooltip-value-sub-label">${this.point.valueSubLabel}</span>`
        : '';

    const valueContext = this.point.valueContext || '';
    const dateContextLabel = this.point.dateContextLabel
        ? `<div class="chart-tooltip-date-context">${this.point.dateContextLabel}</div>`
        : '';

    const isNotDxPieOtherSeries = this.point?.id !== 'otherSeries';
    const footerMessage =
        this.series.userOptions.expandable && isNotDxPieOtherSeries
            ? '<div class="chart-tooltip-footer">Click to view details</div>'
            : '';

    const isAggregateTypeChart = !!get(this.point, 'isAggregateTypeChart', false);
    const tooltipBody =
        body && !isAggregateTypeChart
            ? body
            : `
            ${periodLabel}
            ${dateRangeLabel}
            <div class="chart-tooltip-value-label">${valueLabel}${valueSubLabel}</div>
            <div class="chart-tooltip-value-context">${valueContext}</div>
            ${dateContextLabel}
        `;

    // We escape the point/series name because it is user-inputted content that could have special characters.
    return `
        <div class="chart-tooltip-content">
            <div class="chart-tooltip-header">
                <div class="chart-tooltip-icon">
                    ${colorIcon}
                    ${appIcon}
                </div>
                <div class="chart-tooltip-title-container">
                    <span class="chart-tooltip-title">${sanitizeHtml(this.point.name || this.series.name)}</span>
                    <span class="chart-tooltip-subtitle">${sanitizeHtml(
        this.point.subtitle || this.series.subtitle,
    )}</span>
                </div>
            </div>
            <div class="chart-tooltip-body">
                ${tooltipBody}
            </div>
            ${footerMessage}
        </div>`;
};
